module.exports = __webpack_public_path__ + "img/img_t_3_deco.c7cd34f5.png";